import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";
import { UserDTO } from "../Roles/TenantAPI";

export interface GetUsersResponse {
    users: UsersListDTO[];
}

export interface UsersListDTO {
    id: number;
    firstname: string;
    lastname: string;
    blocked: boolean;
    globalRole: string;
    department: string;
}

export interface UsersGridListDTO {
    // filterd data for the grid
    id: number;
    userName: string;
    blocked: boolean;
    globalRole: string;
    department: string;
}

export async function GetUsers(tenantToken: string): Promise<iEmsApiResponseBody<GetUsersResponse>> {
    return await CallEmsApi<GetUsersResponse>(tenantToken, "GET", "Users");
}

export interface GetUserResponse extends UserDTO {
    externalUserID: string;
    email: string;
    telephone: string;
    facsimile: string;
    mobile: string;
    shiftLength: number;
    blocked: boolean;
    disableAssignment: boolean;
    legacyUserSettings: string;
    departmentID: number;
    legacyRoleID: number;
    globalRoleID: number;
}

export interface UpdateUserRequest extends GetUserResponse {}

export interface CreateUserRequest extends GetUserResponse {
    firstName?: string;
    lastName?: string;
}

export interface MailboxMembership {
    mailboxID: number;
    roleID: number;
}

export interface MailboxMembershipResponse extends GetUserResponse {
    items: MailboxMembership[];
}

export interface UserMailboxMembership {
    userId: number;
    mailboxes: MailboxMembership[];
}

export async function GetUser(tenantToken: string, id: number): Promise<iEmsApiResponseBody<GetUserResponse>> {
    return await CallEmsApi<GetUserResponse>(tenantToken, "GET", `Users/${id}`);
}

export async function UpdateUser(
    tenantToken: string,
    id: number,
    request: UpdateUserRequest,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Users/${id}`, request);
}

export async function CreateUser(
    tenantToken: string,
    id: number,
    request: CreateUserRequest,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "POST", `Users`, request);
}

export async function DeleteUser(tenantToken: string, id: number): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `Users/${id}`);
}

// Membershp //

export async function GetMembership(
    tenantToken: string,
    id: number,
): Promise<iEmsApiResponseBody<MailboxMembershipResponse>> {
    return await CallEmsApi<MailboxMembershipResponse>(tenantToken, "GET", `Users/${id}/Membership`);
}

export async function UpdateMembership(
    tenantToken: string,
    id: number,
    request: UserMailboxMembership,
): Promise<iEmsApiResponse> {
    return await CallEmsApi<any>(tenantToken, "PUT", `Users/${id}/Membership`, request);
}
